<template>
  <div>
    <p class="text-muted mb-1">
    {{ trans('to_pay_now') }}
    </p>
    <h2>
      <dollar :value="adjustedPaymentAmount"/>
    </h2>
    <div v-if="showConvenienceFeePreview">
      <small>{{ trans('includes') }} {{ convenienceFeeLabelDetail }}: </small>
      <dollar :value="convenienceFeePrice" />
      <div v-if="convenienceFeeTaxes">
        <small v-if="convenienceFeeTaxesNames">+ {{ convenienceFeeTaxesNames }}: </small>
        <dollar :value="convenienceFeeTaxes" />
      </div>
      <div v-if="convenienceFeeTaxes">
        <small>{{ trans('total') }} {{ trans('for') }} {{ convenienceFeeLabel }}: </small>
        <dollar :value="convenienceFeePrice + convenienceFeeTaxes" />
      </div>
      <small v-if="hasItemsWithDisabledFees" class="text-danger d-block">
        {{ trans('warning_items_with_disabled_fees') }}
      </small>
    </div>
    <div v-if="invoice.applied_gift_card_amount > 0">
      <h4 class="text-muted mb-0">
        <dollar :value="invoice.applied_gift_card_amount" />
      </h4>
      <p class="text-muted">
        <small>{{ trans('applied_gift_cards') }}</small>
      </p>
    </div>
    <div v-if="invoice.pay_later_amount > 0">
      <p v-if="invoice.pay_now_amount > 0" class="text-muted">
        <small>{{ trans('pay_now_about') }}</small>
      </p>
      <p class="text-muted mb-1 mt-4">
        {{ trans('to_pay_later') }}
      </p>
      <h4 class="text-muted">
        <dollar :value="invoice.pay_later_amount" />
      </h4>
      <p class="text-muted">
        <small>{{ invoice.pay_later_instructions || trans('pay_later_about') }}</small>
      </p>
    </div>
  </div>
</template>

<script>
  import Dollar from './../billing/Dollar'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      showConvenienceFeePreview: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Dollar,
    },
    data() {
      return {
        trans: trans,
      }
    },
    computed: {
      hasItemsWithDisabledFees() {
        if (!this.invoice.invoice_items || this.invoice.invoice_items.length <= 0) return false
        return _.some(this.invoice.invoice_items, (item) => {
          return item.package?.disable_convenience_fee && item.balance > 0
        })
      },
      actualAmountToAddFeeTo() {
        let total = this.invoice.pay_now_amount
        let unChargeable = 0
        _.each(this.invoice.invoice_items, ii => {
          if (ii.package?.disable_convenience_fee || false) unChargeable += ii.balance
        })
        if (isNaN(unChargeable)) unChargeable = 0
        total -= unChargeable
        return total
      },
      convenienceFeeLabelDetail() {
        let percent = this.organization.convenience_fee_percentage * 100
        return `${this.convenienceFeeLabel} (${percent}% ${trans('of_de')} ${_.currency(this.actualAmountToAddFeeTo)})`
      },
      convenienceFeeLabel() {
        return this.organization.convenience_fee_label || this.trans('credit_card_convenience_fee')
      },
      convenienceFeePrice() {
        if (!this.invoice.invoice_items || this.invoice.invoice_items.length <= 0) return
        let convenience_fee = this.organization.convenience_fee_percentage * parseFloat(this.actualAmountToAddFeeTo)
        if (isNaN(convenience_fee)) return 0
        return _.round(convenience_fee, 2)
      },
      convenienceFeeTaxes() {
        if (!this.organization.convenience_fee_taxes || this.organization.convenience_fee_taxes.length == 0) return null
        let total_tax_percent = _.reduce(this.organization.convenience_fee_taxes, (sum, tax) => {
            return sum + parseFloat(tax.percentage || 0)
        }, 0)
        if (!total_tax_percent) return null
        return _.round(this.convenienceFeePrice * (total_tax_percent / 100), 2)
      },
      convenienceFeeTaxesNames() {
        if (!this.organization.convenience_fee_taxes || this.organization.convenience_fee_taxes.length == 0) return null
        return _.map(this.organization.convenience_fee_taxes, tax => tax.name).join(', ')
      },
      adjustedPaymentAmount() {
        let total = this.invoice.pay_now_amount
        if (this.showConvenienceFeePreview && this.convenienceFeePrice > 0) {
          total += this.convenienceFeePrice
          if (this.convenienceFeeTaxes) {
            total += this.convenienceFeeTaxes
          }
        }
        return total
      },
    },
    watch: {
      convenienceFeePrice() {
        this.$emit('convenience-fee-price', this.convenienceFeePrice)
      },
      adjustedPaymentAmount() {
        this.$emit('adjusted-payment-amount', this.adjustedPaymentAmount)
      },
    },
    mounted() {
      window.checkoutPayAmount = this
      this.$nextTick(() => {
        this.$emit('convenience-fee-price', this.convenienceFeePrice)
        this.$emit('adjusted-payment-amount', this.adjustedPaymentAmount)
      })
    },
  }
</script>